export const mockUser = {
  id: '1',
  nickname: '轻醒旅人',
  avatar: '',
  signature: '在微小积累中改变',
  registerDays: 42,
};

export const mockStats = {
  totalFocusHours: 68,
  totalCheckIns: 156,
  streakDays: 12,
  todayFocusMinutes: 85,
  habitProgress: { done: 4, total: 6 },
};

export const mockHabits = [
  {
    id: '1',
    name: '晨间阅读',
    icon: 'ri-book-open-line',
    color: '#B5C6E0',
    progress: { done: 4, total: 7 },
    streak: 8,
    checkedToday: false,
  },
  {
    id: '2',
    name: '冥想5分钟',
    icon: 'ri-mental-health-line',
    color: '#C5B9D8',
    progress: { done: 6, total: 7 },
    streak: 12,
    checkedToday: true,
  },
  {
    id: '3',
    name: '深呼吸3次',
    icon: 'ri-lungs-line',
    color: '#B8D4C8',
    progress: { done: 3, total: 7 },
    streak: 3,
    checkedToday: false,
  },
  {
    id: '4',
    name: '喝8杯水',
    icon: 'ri-drop-line',
    color: '#D4C5B9',
    progress: { done: 5, total: 7 },
    streak: 5,
    checkedToday: true,
  },
  {
    id: '5',
    name: '早起一杯水',
    icon: 'ri-cup-line',
    color: '#C8D4B8',
    progress: { done: 2, total: 7 },
    streak: 2,
    checkedToday: false,
  },
  {
    id: '6',
    name: '睡前拉伸',
    icon: 'ri-walk-line',
    color: '#D8C5C5',
    progress: { done: 7, total: 7 },
    streak: 15,
    checkedToday: true,
  },
];

export const mockTodos = [
  { id: '1', text: '完成今日阅读计划', done: false },
  { id: '2', text: '整理工作笔记', done: true },
  { id: '3', text: '回复重要邮件', done: false },
];

export const mockRecommendedHabits = [
  { id: 'r1', name: '深呼吸3次', duration: '1分钟', icon: 'ri-lungs-line' },
  { id: 'r2', name: '感恩日记', duration: '3分钟', icon: 'ri-quill-pen-line' },
  { id: 'r3', name: '冥想放松', duration: '5分钟', icon: 'ri-mental-health-line' },
];

export const mockBadges = [
  { id: '1', name: '初醒·7天', icon: 'ri-seedling-line', earned: true },
  { id: '2', name: '坚持·30天', icon: 'ri-plant-line', earned: true },
  { id: '3', name: '专注达人', icon: 'ri-focus-3-line', earned: true },
  { id: '4', name: '习惯大师', icon: 'ri-award-line', earned: false },
  { id: '5', name: '百日坚持', icon: 'ri-trophy-line', earned: false },
  { id: '6', name: '全勤之星', icon: 'ri-star-line', earned: false },
  { id: '7', name: '早起达人', icon: 'ri-sun-line', earned: true },
  { id: '8', name: '冥想新手', icon: 'ri-heart-line', earned: true },
];

export const mockHeatmap = [
  { day: 1, level: 1 }, { day: 2, level: 0 }, { day: 3, level: 2 }, { day: 4, level: 3 },
  { day: 5, level: 1 }, { day: 6, level: 2 }, { day: 7, level: 3 }, { day: 8, level: 0 },
  { day: 9, level: 1 }, { day: 10, level: 3 }, { day: 11, level: 2 }, { day: 12, level: 1 },
  { day: 13, level: 3 }, { day: 14, level: 2 }, { day: 15, level: 0 }, { day: 16, level: 1 },
  { day: 17, level: 3 }, { day: 18, level: 2 }, { day: 19, level: 1 }, { day: 20, level: 3 },
  { day: 21, level: 2 }, { day: 22, level: 1 }, { day: 23, level: 0 }, { day: 24, level: 2 },
  { day: 25, level: 3 }, { day: 26, level: 1 }, { day: 27, level: 2 }, { day: 28, level: 3 },
  { day: 29, level: 1 }, { day: 30, level: 2 },
];

export const mockGrowthRecords = [
  { id: '1', date: '2026-04-19', photos: ['https://readdy.ai/api/search-image?query=person%20journaling%20in%20morning%20light%20soft%20purple%20lavender%20aesthetic%20cozy%20desk%20notebook%20pen%20warm%20glow%20minimalist%20lifestyle%20photography%20pastel%20tones%20serene%20atmosphere&width=400&height=400&seq=gr1&orientation=squarish'], note: '今天完成了晨间阅读，感觉很充实！', habitIds: ['1', '2'] },
  { id: '2', date: '2026-04-18', photos: ['https://readdy.ai/api/search-image?query=meditation%20yoga%20mat%20purple%20lavender%20candle%20peaceful%20morning%20routine%20mindfulness%20soft%20light%20minimalist%20room%20zen%20atmosphere%20lifestyle&width=400&height=400&seq=gr2&orientation=squarish', 'https://readdy.ai/api/search-image?query=glass%20of%20water%20morning%20sunlight%20purple%20tones%20healthy%20lifestyle%20fresh%20start%20minimalist%20photography%20clean%20aesthetic&width=400&height=400&seq=gr3&orientation=squarish'], note: '冥想了10分钟，状态很好', habitIds: ['2', '3'] },
  { id: '3', date: '2026-04-17', photos: ['https://readdy.ai/api/search-image?query=reading%20book%20cozy%20purple%20lavender%20aesthetic%20soft%20light%20bookshelf%20warm%20atmosphere%20lifestyle%20photography%20minimalist&width=400&height=400&seq=gr4&orientation=squarish'], note: '读完了一章节，很有收获', habitIds: ['1'] },
];

export const mockFocusHistory = [
  { date: '04-07', minutes: 50 },
  { date: '04-08', minutes: 75 },
  { date: '04-09', minutes: 25 },
  { date: '04-10', minutes: 100 },
  { date: '04-11', minutes: 60 },
  { date: '04-12', minutes: 85 },
  { date: '04-13', minutes: 85 },
];

export const mockWhiteNoises = [
  { id: 'rain', name: '雨声', icon: 'ri-rainy-line' },
  { id: 'fire', name: '篝火', icon: 'ri-fire-line' },
  { id: 'forest', name: '森林', icon: 'ri-tree-line' },
  { id: 'cafe', name: '咖啡馆', icon: 'ri-cup-line' },
  { id: 'wave', name: '海浪', icon: 'ri-water-flash-line' },
];
